import moment from "moment";
import "moment-timezone";

const formatTime = (time, userTimezone) => {
  let parseRunTime = "---";

  if (time && typeof time === 'string' || time instanceof String) {
    const momentHolder = moment(time);
    parseRunTime = momentHolder
      .tz(userTimezone)
      .format("MM-DD-YYYY [at] HH:mma z");
  }
  else if (time && time === -1) {
    const momentHolder = moment(time);
    parseRunTime = momentHolder
      .tz(userTimezone)
      .format("MM-DD-YYYY [at] HH:mma z");
  }
  return parseRunTime;
};

export default formatTime;
